<template>
  <div>
      <Head :title="__(title)" />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
              <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Name')" />
              <text-input v-model="form.level" :error="form.errors.level" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Level')" />
          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">{{ __('Delete Priority') }}
            </button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">{{ __('Update Priority') }}
            </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import { Link, Head } from '@inertiajs/vue3'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo() {
    return { title: this.form.name }
  },
  components: {
    LoadingButton,
    TextInput,
    Link,
      Head,
  },
  layout: Layout,
  props: {
      title: String,
    priority: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
          name: this.priority.name,
          level: this.priority.level,
      }),
    }
  },
  created() {
  },
  methods: {
    update() {
      // Validate that level is a number before submitting
      if (isNaN(this.form.level) || this.form.level === null || this.form.level === '') {
        this.form.errors.level = this.__('Level must be a number');
        return;
      } else {
        this.form.errors.level = null;
      }
      this.form.put(this.route('priorities.update', this.priority.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this priority?')) {
        this.$inertia.delete(this.route('priorities.destroy', this.priority.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this priority?')) {
        this.$inertia.put(this.route('priorities.restore', this.priority.id))
      }
    },
  },
}
</script>
